import ActionsMenu from "../../../../components/action-buttons/ActionsMenu";
import {Empty, Skeleton} from "antd";
import {
  MedicineBoxOutlined,
  PhoneOutlined,
  TeamOutlined
} from "@ant-design/icons";
import "./style.less";
import {FC} from "react";
import {VacanciesListProps} from "../../types";
import {useAuth} from "../../../../context/authContext";

const CONTACT_PHONE = "+380950076071";
const CONTACT_PHONE_LABEL = "+38 (095) 007-60-71";

const VacanciesList: FC<VacanciesListProps> = ({vacancyController}) => {
  const {canManageContent} = useAuth();
  const {vacanciesList, isLoading, confirmDeleteRecord, editButtonHandler} = vacancyController;

  return <section className="vacancies-section">
    <div className="vacancies-intro">
      <div className="vacancies-intro__icon"><TeamOutlined/></div>
      <div>
        <div className="vacancies-intro__eyebrow">Приєднуйтесь до команди</div>
        <h1 className="vacancies-intro__title">Відкриті вакансії</h1>
        <p className="vacancies-intro__description">
          Шукаємо фахівців, які хочуть розвиватися, допомагати людям і працювати у професійній медичній команді.
        </p>
      </div>
    </div>

    {isLoading && !vacanciesList.length ? <div className="vacancies-grid">
      {Array.from({length: 6}).map((_, index) => <div className="vacancy-skeleton" key={index}>
        <Skeleton active paragraph={{rows: 2}}/>
      </div>)}
    </div> : vacanciesList.length ? <>
      <div className={`vacancies-grid ${isLoading ? "vacancies-grid--updating" : ""}`}>
        {vacanciesList.map((vacancy, index) => <article className="vacancy-card" key={vacancy.$id || vacancy.name}>
          <div className="vacancy-card__top">
            <span className="vacancy-card__icon"><MedicineBoxOutlined/></span>
            <span className="vacancy-card__number">{String(index + 1).padStart(2, "0")}</span>
          </div>
          <div className="vacancy-card__label">Актуальна вакансія</div>
          <h2 className="vacancy-card__title">{vacancy.name}</h2>

          {canManageContent && <div className="vacancy-card__actions">
            <ActionsMenu onEdit={() => editButtonHandler(vacancy)} onDelete={() => confirmDeleteRecord(vacancy.$id || "")}/>
          </div>}
        </article>)}
      </div>

      <div className="vacancies-contact">
        <div className="vacancies-contact__icon"><PhoneOutlined/></div>
        <div className="vacancies-contact__content">
          <div className="vacancies-contact__label">Детальна інформація</div>
          <h2>Зацікавила вакансія?</h2>
          <p>Зателефонуйте нам, щоб дізнатися більше про умови роботи та вимоги до кандидатів.</p>
        </div>
        <a className="vacancies-contact__phone" href={`tel:${CONTACT_PHONE}`}>
          <PhoneOutlined/> {CONTACT_PHONE_LABEL}
        </a>
      </div>
    </> : <div className="vacancies-empty">
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={<span>Наразі відкритих вакансій немає.<br/>Слідкуйте за оновленнями.</span>}
      />
    </div>}
  </section>;
};

export default VacanciesList;
